export const locale = {
    lang: "es",
    data: {
        GLOBAL: {
            SavedChanges: "Cambios Guardados",
            CreatedSuccess: "Creado con éxito",
        },
        USERS: {
            Users: "Ususarios",
            Name: "Nombre",
            Email: "Email",
            Admin: "Administrador",
            IsAdmin: "Es Administrador?",
            Password: "Password",
            ADD: "AÑADIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCELAR",
            Create: "Crear",
            UserName: "Nombre",
            BasicInfo: "Información básica",
            PasswordPolicy: "La contraseña debe tener al menos {{minLength}} caracteres.",
            PasswordRequired: "La contraseña es obligatoria",
            PasswordMinLength: "La contraseña debe tener al menos {{minLength}} caracteres.",
            PasswordReset: "Restablecer contraseña",
            PasswordResetTitle: "Cambiar la contraseña del usuario",
            PasswordResetSuccess: "Contraseña actualizada correctamente",
            ResetPasswordButton: "Restablecer contraseña",
            NewPassword: "Nueva contraseña",
            ConfirmPassword: "Confirmar contraseña",
            ConfirmPasswordRequired: "Debes confirmar la contraseña",
            PasswordsDoNotMatch: "Las contraseñas no coinciden",
            Projects: "Proyectos",
            Companies: "Empresas",
        },
        COMPANIES: {
            Companies: "Empresas",
            Name: "Nombre",
            Street: "Calle",
            City: "Ciudad",
            ZipCode: "Código Postal",
            Country: "País",
            BasicInfo: "Info Básica",
            Company: "Empresa",
            CompanyName: "Nombre Empresa",
            Address: "Dirección",
            ADD: "AÑADIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCEL",
            Projects: "Proyectos",
            Create: "Crear",
        },
        DEVICES: {
            ActiveProject: "Proyecto Activo",
            Devices: "Dispositivos",
            Name: "Nombre",
            Manufacturer: "Fabricante",
            Model: "Modelo",
            SerialNumber: "Número Serie",
            DataFrequency: "Frecuencia de Datos (Segundos)",
            DataFrequencyDevice: "Frecuencia de Datos Dispositivo (Seconds): ",
            DataFrequencyCustom: "Frecuencia de Datos Custom (Seconds): ",
            LF010Host: "Host / IP LF010",
            LF010HostHelp: "Host para consultar datos del dispositivo.",
            LF010HostPlaceholder: "192.168.1.100",
            LF010Password: "Contraseña LF010",
            LF010PasswordHelp: "Contraseña opcional. Déjala vacía para usar el valor por defecto actual.",
            LF010PasswordPlaceholder: "admin",
            LF010PeriodMapping: "Asignación de periodos LF010",
            LF010PeriodMappingHelp: "Asigna los tres periodos fijos del LF010 a los periodos del proyecto.",
            LF010DevicePeriod: "Periodo del dispositivo LF010",
            LF010ProjectPeriodPlaceholder: "Selecciona un periodo del proyecto",
            LF010ApplyAlarm: "Aplicar límites LF010 al guardar",
            LF010ApplyAlarmHelp: "Crea o actualiza la alarma de emisión gestionada por LF010 usando la asignación seleccionada.",
            LF010ApplyAlarmPendingHelp:
                "Ya puedes guardar la asignación de periodos. La alarma se podrá aplicar cuando la primera ingestión LF010 aporte los límites de emisión.",
            ProjectPeriod: "Periodo del proyecto",
            LF010SettingsDisabledWhenActive: "Desactiva el dispositivo antes de cambiar la configuración del LF010.",
            LF010LockedBadge: "Dispositivo en vivo",
            LF010LockedTitle: "Los límites y la asignación de periodos del LF010 quedan bloqueados mientras el dispositivo está activo.",
            LF010LockedDescription:
                "La conexión actual del LF010 y la asignación de periodos del proyecto siguen visibles como referencia, pero no se pueden editar hasta desactivar el dispositivo.",
            LF010PeriodMappingLockedHelp:
                "Desactiva el dispositivo para editar la asignación LF010 o cambiar cómo se aplican sus límites en vivo.",
            SimOrImei: "SIM o IMEI",
            LastCalibrationDate: "Fecha de última calibración",
            DeviceType: "Tipo",
            Protocol: "Protocolo",
            Picture: "Fotografia",
            Comments: "Comentarios",
            Location: "Localización",
            Active: "Activo",
            Device: "Dispositivo",
            Activate: "Activar",
            Deactivate: "Desactivar",
            Reset: "Reiniciar",
            ConfirmReset: "¿Reiniciar ahora el dispositivo {{deviceName}}? La medición se detendrá antes.",
            ResetQueued: "Reinicio solicitado",
            ResetAlreadyPending: "Ya hay un reinicio pendiente para este dispositivo",
            ResetRateLimited: "Espera {{seconds}} segundos antes de solicitar otro reinicio",
            OperationTypeReset: "Reinicio",
            OperationTypeGeneric: "Operación",
            OperationPending: "Operación pendiente",
            OperationInProgress: "Operación en curso",
            OperationRequestedAt: "Solicitada {{time}}",
            EditLockedBadge: "Bloqueado",
            EditLockedTitle: "Este dispositivo está activo y no se puede editar.",
            EditLockedDescription: "Desactiva este dispositivo antes de cambiar su configuración, su imagen o sus alarmas especiales.",
            EditLockedMeta: "Desactívalo para desbloquear toda la configuración",
            Remove: "Eliminar",
            Create: "Crear",
            DeviceInfo: "Información",
            SpecialAlarms: "Alarmas especiales",
            SpecialAlarmsHelp:
                "Configura las notificaciones de conectividad y alimentación de este dispositivo usando los canales del proyecto.",
            SpecialAlarmConnection: "Notificar cuando el dispositivo quede fuera de línea o vuelva a conectarse",
            SpecialAlarmPowerSupply: "Notificar cuando el dispositivo se desconecte o vuelva a conectarse a la corriente",
            SpecialAlarmChannels: "Canales de notificación",
            SpecialAlarmChannelsHelp:
                "Los canales seleccionados se comparten entre ambos grupos de alarmas especiales de este dispositivo.",
            SpecialAlarmChannelsEmpty:
                "Crea primero canales de notificación del proyecto para enviar alarmas especiales desde este dispositivo.",
            DefaultSvantekConfig: "Configuración Svantek por defecto",
            DefaultSvantekConfigHelp: "Esta es la configuración que EMMA aplica cuando la configuración personalizada está vacía.",
            CustomConfig: "Configuración Svantek personalizada",
            CustomConfigDisabledWhenActive: "Desactiva el dispositivo antes de cambiar la configuración Svantek personalizada.",
            CustomConfigHelp: "Déjalo vacío para usar la configuración Svantek por defecto de Axioma incluida en EMMA.",
            CustomConfigPlaceholder: "Pega la cadena completa de configuración de Svantek, empezando por #1",
            SvantekFileSync: "Sincronización SVL y descargas",
            SvantekFileSyncEnabled: "Activar descargas",
            SvantekFileSyncHelp:
                "Activa las descargas diarias de CSV, la sincronización del logger .SVL activo y las lecturas de ficheros Svantek de este dispositivo.",
            SvantekBaselineSummary: "Resumen base de EMMA",
            SvantekBaselineSummaryHelp: "Estos valores siguen siendo solo de lectura porque la ingesta de datos de EMMA depende de ellos.",
            SvantekOptionalFeatures: "Funciones opcionales",
            SvantekOptionalFeaturesHelp:
                "Los controles visuales solo reescriben los tokens Svantek compatibles y conservan el resto de la configuración.",
            SvantekAdvancedRawConfig: "Configuración raw avanzada",
            SvantekAdvancedRawConfigHelp:
                "La cadena raw sigue siendo la fuente de verdad. Edítala directamente para ajustes no soportados o control manual completo.",
            SvantekRawConfigPreview: "Vista previa de la configuración personalizada",
            SvantekRawConfigMissing: "Faltan respecto a la configuración por defecto",
            SvantekRawConfigInvalid:
                "No se ha podido interpretar la configuración raw de Svantek. Corrígela o vacíala para volver a activar el editor visual.",
            SvantekCompatibilityWarning:
                "La configuración raw cambia tokens base de EMMA. Se seguirá guardando, pero la compatibilidad de los datos puede verse afectada.",
            SvantekUseInstrumentDefault: "Usar valor por defecto del equipo",
            SvantekOn: "Activado",
            SvantekOff: "Desactivado",
            SvantekEnvironmental: "Ambiental",
            SvantekAirport: "Aeropuerto",
            SvantekMicrophoneCompensation: "Compensación del micrófono",
            SvantekFreeFieldCompensation: "Compensación de campo libre",
            SvantekWaveRecordingMode: "Modo de grabación wave",
            SvantekWaveRecordingOff: "Desactivado",
            SvantekWaveRecordingContinuous: "Continua",
            SvantekWaveRecordingSlopePlus: "Pendiente+",
            SvantekWaveRecordingSlopeMinus: "Pendiente-",
            SvantekWaveRecordingGradientPlus: "Gradiente+",
            SvantekWaveRecordingManual: "Manual",
            SvantekWaveRecordingIntegrationPeriod: "Periodo de integ.",
            SvantekWaveRecordingLevelPlus: "Nivel+",
            SvantekWaveRecordingLevelMinus: "Nivel-",
            SvantekWaveRecordingExternal: "Externo",
            SvantekWaveRecordingAlarm: "Alarma",
            SvantekWaveFileName: "Nombre del archivo wave",
            SvantekWaveFileNameHelp: "Hasta 8 caracteres en mayúsculas, números o guiones bajos.",
            SvantekWaveFormat: "Formato",
            SvantekFormatPcm: "PCM",
            SvantekFormatExtensible: "Extensible",
            SvantekFormatALaw: "A-Law",
            SvantekBitsPerSample: "Bits por muestra",
            SvantekBits16: "16 bits",
            SvantekBits24: "24 bits",
            SvantekRecordingTime: "Tiempo de grabación (s)",
            SvantekRecordingTimeHelp: "Rango permitido: de 1 a 28800 segundos.",
            SvantekPreTrigger: "Pretrigger (s)",
            SvantekPreTriggerHelp: "Disponible para los modos disparados por nivel.",
            SvantekRecordingFilter: "Filtro de grabación",
            SvantekSamplingRate: "Frecuencia de muestreo",
            SvantekGain: "Ganancia (dB)",
            SvantekGainHelp: "Rango permitido: de 0 a 40 dB.",
            SvantekTriggerLevel: "Nivel de disparo (dB)",
            SvantekTriggerLevelHelp: "Rango permitido: de 24 a 136 dB.",
            SvantekTriggerPeriod: "Periodo de disparo",
            SvantekTriggerPeriodLoggerStep: "Paso del logger",
            SvantekTriggerPeriodHalfMillisecond: "0,5 ms",
            SvantekTriggerPeriod100Milliseconds: "100 ms",
            SvantekTriggerPeriod1Second: "1 s",
            SvantekTriggerGradient: "Gradiente de disparo (dB)",
            SvantekTriggerGradientHelp: "Rango permitido: de 1 a 100 dB por periodo de disparo.",
            SvantekLengthLimit: "Límite de longitud",
            SvantekLengthLimit4Gb: "Límite de archivo de 4 GB",
            SvantekLengthLimitMinutes: "Minutos personalizados",
            SvantekLengthLimitMinutesValue: "Límite de longitud (min)",
            SvantekFilterZ: "Filtro Z",
            SvantekFilterA: "Filtro A",
            SvantekFilterC: "Filtro C",
            SvantekFilterB: "Filtro B",
            SvantekSampling48kHz: "48 kHz",
            SvantekSampling24kHz: "24 kHz",
            SvantekSampling12kHz: "12 kHz",
            SvantekSampling6kHz: "6 kHz",
            SvantekBaselineMeasurementMode: "Modo de medida",
            SvantekBaselineMeasurementModeValue: "1/3 de octava",
            SvantekBaselineStartSynchronization: "Sincronización de inicio",
            SvantekBaselineStartSynchronizationValue: "15 min",
            SvantekBaselineIntegrationPeriod: "Periodo de integración",
            SvantekBaselineIntegrationPeriodValue: "5 min",
            SvantekBaselineRepetitionCycles: "Ciclos de repetición",
            SvantekBaselineRepetitionCyclesValue: "Infinito",
            SvantekBaselineLogger: "Logger",
            SvantekBaselineLoggerValue: "Activado",
            SvantekBaselineProfiles: "Perfiles 1/2/3",
            SvantekBaselineProfilesValue: "A/C peak/Fast, A/C peak/Impulse, C/C peak/Fast",
            SvantekBaselineSpectrumFilter: "Filtro de espectro",
            SvantekBaselineSpectrumFilterValue: "Z",
            SvantekBaselineLoggerStep: "Paso del logger",
            SvantekBaselineLoggerStepValue: "1 s",
            SvantekBaselineLeqDetector: "Detector Leq",
            SvantekBaselineLeqDetectorValue: "Exponencial",
            FolderFTP: "FTP Folder",
            ScheduledRestart: "Reinicio programado",
            ScheduledRestartEnabled: "Activar reinicio automático",
            ScheduledRestartTimezone: "La programación usa la zona horaria {{timezone}}.",
            ScheduledRestartFrequency: "Frecuencia",
            ScheduledRestartWeekly: "Semanal",
            ScheduledRestartMonthly: "Mensual",
            ScheduledRestartWeekday: "Día de la semana",
            ScheduledRestartMonthDay: "Día del mes",
            ScheduledRestartHour: "Hora",
            ScheduledRestartMinute: "Minuto",
            WeekdaySunday: "Domingo",
            WeekdayMonday: "Lunes",
            WeekdayTuesday: "Martes",
            WeekdayWednesday: "Miércoles",
            WeekdayThursday: "Jueves",
            WeekdayFriday: "Viernes",
            WeekdaySaturday: "Sábado",
            XL3Connection: "Conexión XL3",
            XL3ConnectionType: "Tipo de conexión",
            XL3ConnectionLan: "LAN",
            XL3ConnectionConnect: "NTi Connect",
            XL3Host: "Host XL3",
            XL3ConnectKey: "Connect Key",
            XL3Password: "Contraseña XL3",
            TotalStorageMb: "Almacenamiento total (MB)",
            TotalStorageMbHelp: "Se usa para convertir el espacio libre de NTi de MB a porcentaje.",
            Address: "Dirección",
            Latitude: "Latitud",
            Longitude: "Longitud",
            SearchAddress: "Buscar dirección",
            SearchingAddress: "Resolviendo dirección",
            AddressHelp: "Escribe una dirección para obtener sus coordenadas.",
            MapHelp: "También puedes hacer clic en el mapa para fijar las coordenadas.",
            AddressNotFound: "No se han encontrado coordenadas para esa dirección.",
            GeocodeFailed: "No se ha podido resolver la dirección ahora mismo.",
            ReverseGeocodeFailed: "Se han guardado las coordenadas, pero no se ha podido resolver la dirección.",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Projects: "Proyectos",
            ConfirmActivate:
                "Este dispositivo ya está activado en el proyecto {{project}} con el nombre {{deviceName}}. \n¿Está seguro de que desea activarlo?",
            Image: "Imagen",
            Files: "Archivos",
            FileName: "Nombre",
            FileType: "Tipo de archivo",
            FileSize: "Tamaño",
            FileStatus: "Estado",
            FileCreationDate: "Fecha de creación",
            FileUploadDate: "Fecha de subida",
            AllFileTypes: "Todos",
            CsvFiles: "CSV",
            SvlFiles: "SVL",
            Xl3Files: "Archivos XL3",
            FileStartDate: "Fecha inicial",
            FileEndDate: "Fecha final",
            ClearFileFilters: "Limpiar filtros",
            FileDateRangeError: "La fecha final debe ser posterior o igual a la fecha inicial.",
            DownloadFile: "Descargar",
            RescanFileStorage: "Revisar storage",
            RescanFileStorageCompleted: "{{count}} archivos recuperados",
            ReprocessFile: "Reprocesar",
            ReprocessFileQueued: "Reproceso SVL en cola",
            FileStatusUploaded: "Subido",
            FileStatusPendingReprocess: "Pendiente de reproceso",
            FileStatusReprocessing: "Reprocesando",
            FileStatusReprocessFailed: "Reproceso fallido",
            DownloadSelectedFiles: "Descargar selección",
            SelectedFilesCount: "{{count}} seleccionados",
            SelectCurrentPageFiles: "Seleccionar los archivos de la página actual",
            SelectFile: "Seleccionar {{name}}",
            NoFiles: "No hay archivos archivados para este dispositivo.",
            NoFilesMatchFilters: "No hay archivos archivados que coincidan con los filtros actuales.",
            DropFiles: "Arrastre la imagen aquí",
            RemoveImage: "Borra Imagen",
            SearchPlaceholder: "Buscar",
        },
        DEVICE: {
            ALARM: {
                AlarmDeleteTitle: "Alerta",
                AlarmDeleteMessage: "Esta alarma tiene {{activeEvents}} eventos activos. \nSeguro que la quieres eliminar?",
            },
        },
        PROJECTS: {
            Projects: "Proyectos",
            Project: "Proyecto",
            BasicInfo: "Info Básica",
            Name: "Nombre",
            Timezone: "Timezone",
            Create: "Crear",
            Devices: "Dispositivos",
            Alarms: "Alarmas",
            ProjectName: "Nombre del proyecto",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            ProjectPeriodName: "Nombre",
            ProjectPeriodStart: "Hora de Inicio",
            ProjectPeriodEnd: "Hora Final",
            ProjectPeriodHours: "Horas",
            ProjectPeriodMinutes: "Minutos",
            ProjectPeriodNew: "Nuevo Periodo",
            ProjectPeriodEdit: "Editar periodo",
            ProjectPeriodSave: "Guardar periodo",
            ProjectPeriodIntervals: "Intervalos",
            ProjectPeriodAddInterval: "Añadir intervalo",
            ProjectPeriodSplit: "Dividir",
            ProjectPeriodError:
                "ADVERTENCIA: La hora de finalización es anterior a la hora de inicio. Está creando un período que abarca varios días.",
            ProjectPeriodsTimelineHint:
                "Usa la línea de tiempo para revisar los intervalos de cada periodo. Edita un periodo para gestionar sus intervalos.",
            ProjectPeriodSplitHint: "Haz clic para dividir aquí",
            ProjectPeriodsEmptyTitle: "Crea el primer periodo",
            ProjectPeriodsEmptyDescription: "Añade los periodos lógicos que necesites y asigna uno o varios intervalos a cada uno.",
            Dateformat: "Formato Fecha",
            Example: "Ejemplo",
            NotificationChannels: "Canales de notificación",
            NotificationChannelsHelp:
                "Crea canales reutilizables del proyecto y selecciónalos desde las alarmas de dispositivo o proyecto.",
            NotificationChannelAdd: "Añadir canal",
            NotificationChannelNew: "Nuevo canal",
            NotificationChannelEdit: "Editar canal",
            NotificationChannelSave: "Guardar canal",
            NotificationChannelName: "Nombre del canal",
            NotificationChannelTypeLabel: "Tipo de canal",
            NotificationChannelEnabled: "Activo",
            NotificationChannelRemove: "Eliminar canal",
            NotificationChannelSendTest: "Enviar notificación de prueba",
            NotificationChannelTestSent: "Notificación de prueba enviada.",
            NotificationChannelTestFailed: "No se pudo enviar la notificación de prueba.",
            NotificationChannelEmails: "Destinatarios email",
            NotificationChannelEmailsRequired: "Añade al menos un destinatario de email.",
            NotificationChannelPhones: "Números de teléfono",
            NotificationChannelPhonesRequired: "Añade al menos un número de teléfono.",
            NotificationChannelChatIds: "IDs de chat de Telegram",
            NotificationChannelChatIdsRequired: "Añade al menos un ID de chat de Telegram.",
            NotificationChannelLanguage: "Idioma",
            NotificationChannelLanguageHint: "Las notificaciones enviadas por este canal usarán el idioma seleccionado.",
            NotificationChannelTelegramManagedBot:
                "La entrega por Telegram usa el token del bot configurado en el backend. Aquí solo se gestionan los IDs de chat destinatarios.",
            NotificationChannelWebhookUrl: "URL del webhook",
            NotificationChannelWebhookRequired: "La URL del webhook es obligatoria.",
            NotificationChannelListHint: "Usa comas o nuevas líneas para introducir varios valores.",
            NotificationChannelSecretStored: "Ya hay un secreto guardado. Déjalo vacío para conservarlo.",
            NotificationChannelWebPushHelp:
                "Crea aquí el canal web push. Los usuarios del proyecto registran sus propios navegadores desde el flujo de la app para clientes.",
            NotificationChannelType: {
                email: "Email",
                sms: "SMS",
                telegram: "Telegram",
                slack: "Slack",
                teams: "Teams",
                web_push: "Web Push",
            },
            Archive: "Archivar",
            Unarchive: "Desarchivar",
            ShowArchived: "Mostrar Archivados",
        },
    },
};
